import styled from 'styled-components';
import { RoundedButton } from '@trevor/ui-components';

export const AddSubscriptionButton = styled(RoundedButton)`
  border-radius: 50px;
  width: 135px;
  height: 24px;

  color: #061e2d;
  border: 1px solid #061e2d;
  padding: 0;

  font-weight: 700;
  font-size: 10px;
  line-height: 29px;
`;

export const Separator = styled.hr`
  margin: 6px 0;
  border: 1px solid #d4d4d4;
`;

export const SubscriptionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
